export const dialogHelper = {
  methods: {
    showMessageWarningToSuspendedOrDeclinedRetailers: async function () {
      await this.$swal(
        "Attention",
        "Hold Up! In order to continue shopping with Bulletin, we need a bit more information from you. Be on the lookout for a verification email to hit your inbox, and then follow the listed instructions in order to verify your retailer account. If you don’t receive anything from us, please reach out to <a class='underline' href=\"mailto: verification@bulletin.co\">verification@bulletin.co</a>. Thank you!"
      );
    },
    showPossibleInvalidEmailsWarning: function (filteredEmails) {
      this.$swal({
        title: "ATTENTION POSSIBLE INVALID EMAIL",
        html:
          "Please check the email or provide an alternative and try again. <br><p>" +
          filteredEmails.join(", ") +
          "</p>",
      });
    },
  },
};
